export default __webpack_public_path__ + "static/media/step4.ab0bd9cc.png";